import { Location, LocationState } from 'history';
import { action, computed, observable } from 'mobx';
import { RouterStore } from 'mobx-react-router';
import Constants from 'src/config';
import { IUser } from 'src/Definitions';
import { SimpleEntityDto } from 'src/generated_client';

class GlobalStore {
    @computed
    public get isLoggedIn() {
        return !!this.user;
    }

    @computed
    public get isAdmin() {
        if (this.user) {
            return this.user.roles.indexOf(Constants.Roles.Administrator) !== -1;
        }
        return false;
    }

    @computed
    public get isOrganizationAdmin() {
        if (this.user) {
            return this.user.roles.indexOf(Constants.Roles.OrganizationAdministrator) !== -1;
        }
        return false;
    }

    @computed
    public get currentOrganization(): SimpleEntityDto {
        if (this.user) {
            return this.user.organization as SimpleEntityDto;
        }
        return {} as SimpleEntityDto;
    }

    @computed
    public get getCurrentPath() {
        return this.routerStore.location.pathname;
    }

    @observable
    public user?: IUser;

    @observable
    public isDrawerOpen: boolean = false;

    constructor(private routerStore: RouterStore) {}

    @action.bound
    public toggleDrawer() {
        this.isDrawerOpen = !this.isDrawerOpen;
    }

    @action.bound
    public setUser(user: IUser) {
        this.user = user;
    }

    @action.bound
    public clearUser() {
        this.user = undefined;
    }

    @action.bound
    public rerouteToPath(path: string) {
        this.routerStore.push(path);
    }

    @action.bound
    public rerouteIfNotLoggedIn(location?: Location<LocationState>) {
        if (!location) {
            location = this.routerStore.location;
        }
        if (!this.isLoggedIn && location.pathname !== '/login') {
            const previousRoute = btoa(location.pathname + location.search);
            this.routerStore.push('/login?previousRoute=' + previousRoute);
        }
    }

    @action.bound
    public clearUserAndRouteToLogin() {
        this.clearUser();
        this.rerouteIfNotLoggedIn();
    }
}

export default GlobalStore;



// WEBPACK FOOTER //
// ./src/stores/GlobalStore/GlobalStore.ts